<template>
  <!--
    独立客服 iframe 页：不自带按钮，由宿主页（企业站）通过 postMessage 唤醒。
    宿主页点击自己已有的「客服」按钮 → iframe pointer-events 切为 auto 并发来 cs-open。
    面板关闭 → 反向通知宿主页收回 iframe（切回 pointer-events: none）。
  -->
  <div class="customer-widget">
    <CustomerService />
  </div>
</template>

<script>
import Bus from "@/utils/bus";
import CustomerService from "@/components/customerService.vue";

export default {
  name: "CustomerWidget",
  components: { CustomerService },
  methods: {
    // 收到面板开/关 → 通知宿主页切换 iframe 可交互性
    onPanelState(open) {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ type: "cs-resize", open: !!open }, "*");
      }
    },
    // 宿主页（企业站）的「客服」按钮被点击时发来 cs-open
    onParentMessage(e) {
      if (!e.data || e.data.type !== "cs-open") return;
      Bus.$emit("openCustomerService");
    },
  },
  mounted() {
    document.documentElement.style.background = "transparent";
    document.body.style.background = "transparent";

    Bus.$on("customerServicePanelState", this.onPanelState);
    window.addEventListener("message", this.onParentMessage);
  },
  beforeDestroy() {
    Bus.$off("customerServicePanelState", this.onPanelState);
    window.removeEventListener("message", this.onParentMessage);
  },
};
</script>
